module.exports = __webpack_public_path__ + "img/logo-iris-assistance.56ed269c.png";